/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Drawer, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { getBmi } from '../../../constants/helper'

import AvatarUplaod from '../../../components/Custom/AvatarUpload'
import AddressForm from './DataFields/address'
import DemographyForm from './DataFields/demography'
import EducationForm from './DataFields/education'
import HealthForm from './DataFields/health'
import EmploymentForm from './DataFields/employment'
import OthersForm from './DataFields/others'
import VotersForm from './DataFields/voters'

import TakePhoto from '../../../components/Custom/TakePhoto'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedHousehold: null
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedConstituent, form, fromHousehold } = this.props
		const { setFieldsValue } = form
		if (selectedConstituent) {
			this.setState({ selectedHousehold: { uid: selectedConstituent.household_uid } }, () => {
				setFieldsValue({
					household_uid: selectedConstituent.household_no,
					id_number: selectedConstituent.id_number,
					house_no: selectedConstituent.house_no,
					block: selectedConstituent.block,
					lot: selectedConstituent.lot,
					street: selectedConstituent.street,
					address: selectedConstituent.address,
					purok_name: selectedConstituent.purok_name,
					first_name: selectedConstituent.first_name,
					middle_name: selectedConstituent.middle_name,
					last_name: selectedConstituent.last_name,
					gender: selectedConstituent.gender,
					birthday: moment(selectedConstituent.birthday),
					civil_status: selectedConstituent.civil_status,
					contact_no: selectedConstituent.contact_no,
					citizenship: selectedConstituent.citizenship,
					birth_place: selectedConstituent.birth_place,
					residency_ownership: selectedConstituent.residency_ownership,
					residency_date: moment(selectedConstituent.residency_date).isValid() ? moment(selectedConstituent.residency_date) : null,
					nuclear_family: selectedConstituent.nuclear_family,
					relation_in_head: selectedConstituent.relation_in_head,
					others_relation_in_head: selectedConstituent.others_relation_in_head,
					religion: selectedConstituent.religion,
					other_religion: selectedConstituent.other_religion,
					schooling: selectedConstituent.schooling,
					school_type: selectedConstituent.school_type,
					year_level: selectedConstituent.year_level,
					course: selectedConstituent.course,
					educational_attainment: selectedConstituent.educational_attainment,
					pwd: selectedConstituent.pwd,
					disability_type: selectedConstituent.disability_type,
					other_disability: selectedConstituent.other_disability,
					with_pwd_id: selectedConstituent.with_pwd_id,
					with_senior_id: selectedConstituent.with_senior_id,
					pregnant: selectedConstituent.pregnant,
					is_teenage_pregnancy: selectedConstituent.is_teenage_pregnancy,
					illness: selectedConstituent.illness,
					other_illness: selectedConstituent.other_illness,
					respiratory_issue: selectedConstituent.respiratory_issue,
					other_respiratory_issue: selectedConstituent.other_respiratory_issue,
					maternal_death: selectedConstituent.maternal_death,
					contacted_covid: selectedConstituent.contacted_covid,
					solo_parent: selectedConstituent.solo_parent,
					height: selectedConstituent.height,
					weight: selectedConstituent.weight,
					ofw: selectedConstituent.ofw,
					employed: selectedConstituent.employed,
					with_business: selectedConstituent.with_business,
					occupation_code: selectedConstituent.occupation_code,
					occupation_others: selectedConstituent.occupation_others,
					industry_code: selectedConstituent.industry_code,
					class_of_worker: selectedConstituent.class_of_worker,
					nature_of_employment: selectedConstituent.nature_of_employment,
					total_salary_peso: selectedConstituent.total_salary_peso,
					total_salary_goods: selectedConstituent.total_salary_goods,
					looking_for_job: selectedConstituent.looking_for_job,
					reason_not_looking_job: selectedConstituent.reason_not_looking_job,
					activity_past_3mos: selectedConstituent.activity_past_3mos,
					where_work_past_3mos: selectedConstituent.where_work_past_3mos,
					experienced_hunger: selectedConstituent.experienced_hunger,
					victim_of_crime: selectedConstituent.victim_of_crime,
					type_of_crime: selectedConstituent.type_of_crime,
					other_crime: selectedConstituent.other_crime,
					is_alive: selectedConstituent.is_alive,
					voters_id: selectedConstituent.voters_id,
					precint_no: selectedConstituent.precint_no,
					registered_voter: selectedConstituent.registered_voter
				})
			})
		} else if (fromHousehold) {
			this.setState({ selectedHousehold: { uid: fromHousehold.uid } }, () => {
				setFieldsValue({
					household_uid: fromHousehold.household_no,
					house_no: fromHousehold.house_no,
					street: fromHousehold.street,
					address: fromHousehold.address,
					purok_name: fromHousehold.purok_name
				})
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveConstituent, onClose, selectedConstituent } = this.props
		const { selectedHousehold } = this.state
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const fileList = _.has(values.avatar, 'fileList') ? values.avatar.fileList : []
			console.log('fileList', fileList)
			const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			const files = []
			if (formattedFiles.length > 0) {
				files.push(formattedFiles[formattedFiles.length - 1])
			}
			delete values.avatar

			let nutritional_status = null
			if (values.height && values.weight) {
				let bmiValue = values.weight / (values.height * values.height)
				nutritional_status = getBmi(bmiValue)
			}
			let params = Object.assign({}, values, { 
				files, barangay_uid, 
				household_uid: selectedHousehold.uid,
				birthday: moment(values.birthday).format('YYYY-MM-DD'),
				residency_date: moment(values.residency_date).isValid() ? moment(values.residency_date).format('YYYY-MM-DD') : null,
				nutritional_status
			})
			if (selectedConstituent) {
				params = Object.assign({}, params, { constituent_uid : selectedConstituent.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_constituent', content: 'Saving constituent, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveConstituent(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_constituent', content: 'Constituent successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'Constituent',
						action: selectedConstituent ? 'Update' : 'Create',
						message: `${selectedConstituent ? 
							'Update' : 'Created new'} constituent data of ${params.first_name} ${params.last_name} `
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving constituent')
					message.error({ key: 'set_constituent', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { isSaving } = this.state
		const { visible, onClose, form, AuthStore, selectedConstituent, fromHousehold } = this.props
		const { getFieldDecorator } = form
		const { barangay_uid } = AuthStore
        
		return (
			<Drawer
				title={selectedConstituent ? `Update Details of ${selectedConstituent.first_name} ${(selectedConstituent.middle_name ? selectedConstituent.middle_name.substring(0,1) : '')} ${selectedConstituent.last_name}` 
					: 'Add New Constituent'}
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'90%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row type='flex' justify='center'>
						<Form.Item label=''>
							{ getFieldDecorator('avatar', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<AvatarUplaod constituent_uid={selectedConstituent ? selectedConstituent.uid : null} />
							)}
						</Form.Item>
					</Row>

					<legend>Address</legend>
					<Row>
						<Col md={4} sm={24}>
							<Form.Item label='ID Number (leave blank if auto-generated)'>
								{ getFieldDecorator('id_number', {
									//initialValue: null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Input placeholder='Enter ID Number' />
								)}
							</Form.Item>
						</Col>
					</Row>
					<AddressForm 
						form={form} 
						fromHousehold={fromHousehold}
						onSelectedHousehold={(value) => this.setState({ selectedHousehold: value })}
					/>
					
					<legend>Demography</legend>
					<DemographyForm form={form}/>

					<legend>Education</legend>
					<EducationForm form={form}/>

					<legend>Health</legend>
					<HealthForm form={form}/>

					<legend>Employment</legend>
					<EmploymentForm form={form}/>

					<legend>Other Details</legend>
					<OthersForm form={form}/>

					<legend>Voter's Details</legend>
					<VotersForm form={form}/>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button disabled={isSaving} type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_CONSTITUENT = gql`
    mutation setConstituent($input: JSON) {
		setConstituent(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-constituent' }),
	inject('AuthStore'),
	graphql(SET_CONSTITUENT, {
		props({ mutate }) {
			return {
				saveConstituent(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayHousehold','allBarangayConstituents','constituentAvatar','barangayConstituentByUid']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
